<template>
    <v-dialog max-width="1200px" v-model="dialog" persistent>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 0px">
                    Lịch sử điều chuyển
                </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="close"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
                <v-icon>cancel</v-icon>
            </v-btn>
            <v-card-text>
                <v-layout wrap style="padding: 10px;">
                    <v-flex xs12 sm12 md6>
                        <p class="font-weight-bold">
                            Mã quản lý:
                            {{ fixedAssetsCode }}
                        </p>
                        <p class="font-weight-bold">
                            Tên tài sản:
                            {{ fixedAssetsName }}
                        </p>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <p class="font-weight-bold">
                            Bộ phận sử dụng ban đầu:
                            {{ departmentName }}
                        </p>
                        <p class="font-weight-bold">
                            Địa điểm sử dụng ban đầu:
                            {{ locationName }}
                        </p>
                    </v-flex>
                </v-layout>
                <c-search-form
                    :rows-per-page-items="[10, 20, 50]"
                    :fields="fields"
                    key-property="id"
                    search-url="/fixedAssetsTranfer/search?sortField=id&"
                    form-type="intable"
                    @viewItem="viewItem"
                    ref="tableData"
                    :deleteMulti="false"
                    :acceptDelete="false"
                    :acceptView="true"
                    :acceptEdit="false"
                    :hiddenFields="hiddenFields"
                    :displayToolbar="false"
                    orderBy="desc"
                >
                </c-search-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="close">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";

export default {
    name: "tranfer-history",
    components: { CSearchForm },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        propsItem: {
            type: Object,
            default: ()=> {}
        },
        backTo: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            hiddenFields: {
                fixedAssetsId: null,
            },
            fixedAssetsName: '',
            fixedAssetsCode: '',
            locationName: '',
            departmentName: '',
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "10%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "tranferDate",
                    text: "Ngày điều chuyển",
                    headerStyle: "text-align:center",
                    dateFormat: 'dd/MM/yyyy',
                    search: false,
                    type: "datepicker",
                },
                {
                    value: "locationNew",
                    text: "Địa điểm nhận điều chuyển",
                    search: false,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "locationNew",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "departmentNew",
                    text: "Bộ phận nhận điểu chuyển",
                    search: false,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "departmentNew",
                    items: [],
                    itemText: "deptName",
                    itemValue: "deptId",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "15%",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
            lstLocation: [],
            lstDepartment: [],
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    this.fixedAssetsName = value.name;
                    this.fixedAssetsCode = value.code;
                    let locationId = null;
                    let departmentId = null;

                    if (value.fixedAssetsId != undefined) {
                        this.hiddenFields.fixedAssetsId = value.fixedAssetsId;
                        locationId = value.locationFirstId;
                        departmentId = value.departmentFirstId;
                    } else {
                        this.hiddenFields.fixedAssetsId = value.id;
                    }
                    
                    if (locationId != null) {
                        const location = this.lstLocation.find(o => o.categoryId === locationId );
                        if (location !== undefined && typeof location == 'object') {
                            this.locationName = location.categoryName;
                        }
                    }

                    if (departmentId != null) {
                        const department = this.lstDepartment.find(o => o.deptId === departmentId );
                        if (department !== undefined && typeof department == 'object') {
                            this.departmentName = department.deptName;
                        }
                    }
                } else {
                    this.fixedAssetsName = '';
                    this.fixedAssetsCode = '';
                    this.locationName = '';
                    this.departmentName = '';
                    this.hiddenFields.fixedAssetsId = null;
                }
            },
            deep: true,
        },
    },
    created() {
        this.getLocation();
        this.getDepartment();
    },
    computed: {

    },
    methods: {
        close() {
            this.$emit("close");
        },
        viewItem(itemTranfer) {
            // this.$router.push({ path: `/fixedAssetsTranfer/create`, query: {tranferId: itemTranfer.id, backTo: this.backTo} });
            let route = this.$router.resolve({path: '/fixedAssetsTranfer/create', query: {tranferId: itemTranfer.id, backTo: this.backTo} });
            window.open(route.href, '_blank');
        },
        getLocation() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=OFFICE_LOCATION"
                )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstLocation = data;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "locationNew";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );
        },
        getDepartment() {
            axios.post(process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "departmentNew";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.items;
                        }
                    }
                }
            );
        },
    },
    destroyed() {},
};
</script>
